// extracted by mini-css-extract-plugin
export var actions = "Edu-module--actions--0cad9";
export var atTopPage = "Edu-module--atTopPage--5fff3";
export var ctaSection = "Edu-module--ctaSection--bc9ce";
export var extendedMenuSection = "Edu-module--extendedMenuSection--2729a";
export var globalSearch = "Edu-module--globalSearch--7a45f";
export var languageSwitcher = "Edu-module--languageSwitcher--02f1e";
export var logoSection = "Edu-module--logoSection--aa615";
export var mobileCascadeMenu = "Edu-module--mobileCascadeMenu--ea386";
export var mobileCascadeMenuHolder = "Edu-module--mobileCascadeMenuHolder--0f9d6";
export var mobileMenu = "Edu-module--mobileMenu--3cfc4";
export var scrolling = "Edu-module--scrolling--90433";
export var tkAktivGrotesk = "Edu-module--tk-aktiv-grotesk--c0024";
export var tkAktivGroteskCondensed = "Edu-module--tk-aktiv-grotesk-condensed--74463";
export var tkAktivGroteskExtended = "Edu-module--tk-aktiv-grotesk-extended--aa8c9";
export var tkAktivGroteskThin = "Edu-module--tk-aktiv-grotesk-thin--13545";
export var tkNeuzeitGrotesk = "Edu-module--tk-neuzeit-grotesk--5ab38";
export var tkNeuzeitGroteskCondensed = "Edu-module--tk-neuzeit-grotesk-condensed--c7fb8";
export var tkNeuzeitGroteskExtraConden = "Edu-module--tk-neuzeit-grotesk-extra-conden--29fe6";
export var topMenuSection = "Edu-module--topMenuSection--28725";
export var wrapper = "Edu-module--wrapper--1abeb";